export default __webpack_public_path__ + "static/travelbookBanner-0d7cd1a00e776e184f9da7a6ce41c38a.jpg";